<template>
  <div v-if="isLoaded">
    <!-- Inline -->
    <div class="row q-mb-md">
      <!-- Filters hide/show button -->
      <div class="col-6">
      </div>
      <!-- Invite button -->
      <div class="col-6" style="justify-content: flex-end">
        <q-btn v-if="$store.state.meStore.me.rights.includes(`etim.category.add`) || $store.state.meStore.me.su"
          class="capitalize q-ml-md ctrl-button right"
          color="ctrl-turquoise"
          :label="getString('right.etim.category.add')"
          @click="$router.push('/etim/category/add')"
          icon-right="add"
        />
      </div>
    </div>
    <!-- <button @click="allowDrag = !allowDrag">Sort</button> -->
    <draggable :disabled="!$store.state.meStore.me.rights.includes(`etim.category.sort`)" v-model="categories" handle=".handle" v-bind="dragOptions" @start="drag = true" @end="sortCategories()">
      <transition-group type="transition" :name="!drag ? 'flip-list' : null">
        <div v-for="category in categories" :key="category.id">
          <div class="collapse">
            <q-collapsible group="categories">

              <template slot="header">
                <q-item-main>
                  <a :href="`etim/category/${category.id}`">{{ category.name }}</a>
                </q-item-main>
                <q-item-side right>
                  <q-icon name="info" color="primary" size="24px">
                    <q-tooltip>
                      {{ getString('module.etim.tooltip.drag') }}
                    </q-tooltip>
                  </q-icon>
                </q-item-side>
              </template>
              <div :id="category.name" class="q-table q-table__auto">
                <vuetable
                  ref="vuetable"
                  pagination-path
                  :api-mode="false"
                  :data="filtered[category.id] || features[category.id]"
                  :css="css.table"
                  :fields="columns"
                  :row-class="selectable ? applyRowClass : null"
                  @vuetable:row-clicked="selectRows"
                  >
                  <!-- filterable -->
                  <div slot="filterable" slot-scope="props">
                    <q-toggle v-model="props.rowData.filterable"
                      @input="toggle(props.rowData, 'filterable')" color="secondary"
                    />
                  </div>
                  <!-- visible -->
                  <div slot="visible" slot-scope="props">
                    <q-toggle v-model="props.rowData.visible"
                      @input="toggle(props.rowData, 'visible')" color="secondary"
                    />
                  </div>
                  <!-- Brochure -->
                  <div slot="brochure" slot-scope="props">
                    <q-toggle v-model="props.rowData.brochure"
                      @input="toggle(props.rowData, 'brochure')" color="secondary"
                    />
                  </div>
                  <!-- Overview -->
                  <div slot="overview" slot-scope="props">
                    <q-toggle v-model="props.rowData.show_on_overview"
                      @input="toggle(props.rowData, 'show_on_overview')" color="secondary"
                    />
                  </div>
                </vuetable>
              </div>
            </q-collapsible>
            <div class="handle">
              <div class="minimized">
                <q-icon
                  color="grey-1"
                  name="mdi-dots-horizontal"
                  size="1.2rem"
                />
              </div>
            </div>
          </div>
        </div>
      </transition-group>
    </draggable>
    <div class="collapse">
      <q-collapsible :label="getString('module.etim.category.noCategory')" icon-toggle>
        <q-input
          v-model="filters.other"
          :placeholder="getString('searchFeatures')"
          @input="filterFeaures('other')"/>
        <div class="q-table q-table__auto">
          <vuetable
            ref="vuetable"
            pagination-path
            :api-mode="false"
            :data="filtered.other || other"
            :css="css.table"
            :fields="columns"
            @vuetable:row-clicked="selectRows"
            >
            <!-- filterable -->
            <div slot="filterable" slot-scope="props">
              <q-toggle v-model="props.rowData.filterable"
                @input="toggle(props.rowData, 'filterable')" color="secondary"
              />
            </div>
            <!-- visible -->
            <div slot="visible" slot-scope="props">
              <q-toggle v-model="props.rowData.visible"
                @input="toggle(props.rowData, 'visible')" color="secondary"
              />
            </div>
          </vuetable>
        </div>
      </q-collapsible>
      <div class="disable-drag">
        <div class="minimized">
          <q-icon
            color="grey-1"
            name="mdi-dots-horizontal"
            size="1.2rem"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import Vuetable from 'vuetable-2';
import getString from '@/helpers/GetStrings';
import qs from 'qs';
import _debounce from 'lodash.debounce';
import selectRows from '@/mixins/tables/selectRows';

/**
 * This component makes a single request to the product features endpoint and sorts the features by category on the frontend. The
 * The sorted features are given to a table matching the category ID. The table uses data (non-api) mode. The
 * Categories can be dragged in order to reassign sort id's.
 */
export default {
  mixins: [
    selectRows,
  ],
  data() {
    return {
      permission: 'etim.category',
      isLoaded: false,
      selectable: true,
      dragIndex: null,
      drag: false,
      dragging: false,
      features: {},
      other: [],
      filtered: {},
      filters: {
        other: '',
      },
      css: {
        table: {
          tableClass: 'vuetable ui selectable celled stackable attached table vuetable-fixed-layout',
          loadingClass: '',
          ascendingIcon: 'mdi mdi-chevron-up icon',
          descendingIcon: 'mdi mdi-chevron-down icon',
          handleIcon: '',
        },
      },
      categories: [],
      rowSelection: [],
      currentRow: null,
      previousRow: null,
      columns: [
        {
          name: 'code',
          title: getString(null, 'Code', 'Code'),
          sortField: 'visible',
          titleClass: 'text-left sortable vcol-xs',
          dataClass: 'text-left vcol-xs text-ellipsis',
        },
        {
          name: 'label',
          title: 'Label',
          sortField: 'label',
          titleClass: 'text-left sortable vcol-l',
          dataClass: 'text-left vcol-l text-ellipsis',
        },
        {
          name: '__slot:visible',
          title: getString(null, 'Visible on website', 'Zichtbaar op website'),
          sortField: 'visible',
          titleClass: 'text-center sortable vcol-sm',
          dataClass: 'text-center vcol-sm text-ellipsis',
        },
        {
          name: '__slot:filterable',
          title: getString(null, 'Filterable', 'Filterbaar'),
          sortField: 'filterable',
          titleClass: 'text-center sortable vcol-xs',
          dataClass: 'text-center vcol-xs text-ellipsis',
        },
        {
          name: '__slot:brochure',
          title: getString(null, 'Brochure', 'Brochure'),
          sortField: 'filterable',
          titleClass: 'text-center sortable vcol-xs',
          dataClass: 'text-center vcol-xs text-ellipsis',
        },
        {
          name: '__slot:overview',
          title: getString(null, 'Overview', 'Overzicht'),
          sortField: 'filterable',
          titleClass: 'text-center sortable vcol-xs',
          dataClass: 'text-center vcol-xs text-ellipsis',
        },
      ],
    };
  },
  components: {
    draggable,
    Vuetable,
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
      };
    },
  },
  methods: {
    getString,

    setDraggableRows() {
      setTimeout(() => {
        const isDraggable = document.getElementsByClassName('ctrl-row-select');
        [].forEach.call(isDraggable, (element) => {
          element.setAttribute('draggable', true);
        });
      }, 100);
    },

    initTableEvents() {
      this.$nextTick(() => {
        this.categories.forEach((category) => {
          document.getElementById(category.name).addEventListener('dragstart', this.handleDragStart, { passive: true });
          document.getElementById(category.name).addEventListener('dragenter', this.handleDragEnter, { passive: true });
          document.getElementById(category.name).addEventListener('dragend', this.handleDragEnd, { passive: true });
        });
      });
    },

    removeTableEvents() {
      document.removeEventListener('dragstart', this.handleDragStart);
      document.removeEventListener('dragEnd', this.handleDragEnd);
      document.removeEventListener('dragenter', this.handleDragEnter);
    },

    handleDragStart(evt) {
      const dragImg = document.createElement('img');
      evt.dataTransfer.setData('text/plain', 'anything');
      evt.dataTransfer.setDragImage(dragImg, 1, 1);
      this.dragging = true;
    },

    handleDragEnter(evt) {
      this.previousRow = this.currentRow;
      this.dragging && evt.target.click();
    },

    handleDragEnd() {
      this.previousRow = null;
      this.currentRow = null;
      this.rowSelection = [];
      this.dragging = false;
    },

    // Applies a css class to selected rows.
    applyRowClass(dataItem) {
      return this.rowSelection.indexOf(dataItem.id) > -1 ? 'ctrl-row-select' : '';
    },

    sortCategories() {
      const sorted = {};
      this.categories.forEach(category => (Object.assign(sorted, { [`category[${category.id}]`]: this.categories.indexOf(category) + 1 })));

      this.axios.put('etim/category/sort', qs.stringify(sorted));
      this.drag = false;
    },

    putFeaturesSort: _debounce(function (features, id) {
      const sorted = {};
      features.forEach(feature => (Object.assign(sorted, { [`feature[${feature.id}]`]: features.indexOf(feature) + 1 })));
      this.axios.put(`etim/feature/sort/${id}`, qs.stringify(sorted));
    }, 500),

    applySortation(row) {
      // update the sort id of each element in the row selection
      this.features[row.category.id].forEach((feature) => {
        if (this.rowSelection.includes(feature.id)) {
          if (this.previousRow && this.previousRow.sort_id > this.currentRow.sort_id) {
            feature.sort_id = this.dragIndex - 0.1;
          } else if (this.previousRow && this.previousRow.sort_id < this.currentRow.sort_id) {
            feature.sort_id = this.dragIndex + 0.1;
          } else {
            feature.sort_id = this.dragIndex;
          }
        }
      });
      this.features[row.category.id].sort((a, b) => a.sort_id - b.sort_id);

      for (let index = 0; index < this.features[row.category.id].length; index += 1) {
        this.features[row.category.id][index].sort_id = index + 1;
      }

      // Send the sortation put request for the feature category
      this.putFeaturesSort(this.features[row.category.id], row.category.id);
    },

    // Selects rows on row click.
    selectRows(row, event) {
      this.currentRow = row;

      if (this.dragging) {
        // Do not sort while dragging through current selection
        if (this.rowSelection.includes(row.id)) {
          return;
        }

        this.dragIndex = row.sort_id;

        if (this.dragging && this.rowSelection.length) {
          this.applySortation(row);
        }

        // If metaKey is pressed & the row is not in the selection, add to selection
      } else if (!this.rowSelection.includes(row.id) && event.metaKey) {
        this.rowSelection.push(row.id);

      // If metaKey is pressed & the row is already in the selection, remove from selection.
      } else if (this.rowSelection.includes(row.id) && event.metaKey) {
        this.rowSelection.splice(this.rowSelection.indexOf(row.id), 1);

      // If the current row is the only row selected, go to the row detail when clicked again.
      } else if (this.rowSelection.length === 1 && this.rowSelection.includes(row.id)) {
        if (this.$store.state.meStore.me.rights.includes('etim.feature.edit') || this.$store.state.meStore.me.su) {
          !this.dragging && this.$router.push(`/etim/feature/${row.id === 'other' ? row.feature_id : row.id}`);
        }

      // When using shift select, we need to select on row number due to sorted columns.
      } else if (event.shiftKey && this.rowSelection.length) {
        this.shiftSelect(row, this.features[row.category.id].map(feature => feature.id));

      // Simple click sets the clicked row as the rowSelection.
      } else {
        this.rowSelection = [row.id];
      }
      this.setDraggableRows();
    },

    shiftSelect(row, data) {
      // rowIndexes is used to store the positions (row numbers) of the rows.
      // This is sorted so that intermediate rows can be added to rowSelection regardless of id.
      const rowIndexes = [];

      // The row numbers of the first & last rows in the selection.
      const firstRow = data.indexOf(this.rowSelection[0]);
      const lastRow = data.indexOf(this.rowSelection[this.rowSelection.length - 1]);

      // Push the position of the selected row into rowIndexes.
      rowIndexes.push(data.indexOf(row.id));

      // Check if clicked row is above the first rowSelection item.
      if (rowIndexes[0] > firstRow) {
        // If true, push the first rowSelection item.
        rowIndexes.push(firstRow);

        // If false push the last rowSelection item.
      } else {
        rowIndexes.push(lastRow);
      }

      // Sort the rowIndex array from smallest to largest.
      rowIndexes.sort((a, b) => a - b);

      // Empty row selection
      this.rowSelection = [];

      // Select all rows
      for (let i = rowIndexes[0]; i <= rowIndexes[rowIndexes.length - 1]; i += 1) {
        this.rowSelection.push(data[i]);
      }
    },

    // Method to fetch categories
    getCategories() {
      return new Promise((resolve, reject) => {
        this.axios.get('etim/category').then((res) => {
          this.categories = res.data.categories;
          this.categories.forEach((category) => {
            Object.assign(this.features, { [category.id]: [] });
          });
          resolve();
        }).catch((err) => {
          reject(err);
        });
      });
    },

    toggle(rowData, property) {
      const isActive = rowData[property];
      this.axios.put(`/etim/feature/${rowData.id === 'other' ? rowData.feature_id : rowData.id}`, qs.stringify({ [property]: isActive }))
        .then(() => {
          this.$q.notify({
            message: getString(null, 'Successfully updated the item', 'Item succesvol bijgewerkt'),
            color: 'positive',
            icon: 'check',
            position: 'top-right',
          });
        })
        .catch((err) => {
          this.$q.notify({
            message: getString(null, 'Failed to update the item', 'Item bijwerken mislukt'),
            color: 'warning',
            icon: 'warning',
            position: 'top-right',
          });
          console.warn(err);
        });
    },

    filterFeaures(index) {
      this.filtered[index] = (index === 'other' ? this.other : this.features[index])
        .filter(feature => feature.label.toLowerCase().includes(this.filters[index].toLowerCase()))
        .map(feature => ({
          category: feature.category,
          id: feature.id,
          label: this.highlight(feature.label, this.filters[index]),
          visible: feature.visible,
          filterable: feature.filterable,
        }));
    },

    highlight(field, filter) {
      // Build regex to match query string.
      const regex = new RegExp(filter, 'gi');

      // Match and replace query string with highlighted text.
      return field
        .replace(regex, matchedTxt => (`<span class='highlight'>${matchedTxt}</span>`));
    },

    // Method to fetch the product features
    getFeatures() {
      this.axios.get('etim/feature').then((res) => {
        this.sortFeatures(res.data.features);
      }).catch((err) => {
        console.warn(err);
      }).finally(() => {
        this.isLoaded = true;
        this.initTableEvents();
      });
    },

    // Method to sort the features by respective category ID's
    sortFeatures(features) {
      features.forEach((feature) => {
        if (feature.category && this.features[feature.category.id]) {
          this.features[feature.category.id].push(feature);
        } else {
          this.other.push(feature);
        }
      });
    },
  },
  mounted() {
    this.getCategories().then(() => this.getFeatures());
  },
  destroyed() {
    this.removeTableEvents();
  },
};
</script>

<style lang="stylus" scoped>
@import '~variables';
@import '../styles/components/tables.general.styl';
.collapse
  // display flex
  justify-content space-between
  width 100%
  background-color: #fff;
  border-right 2px #ACACAC dashed
  border-top 2px #ACACAC dashed
  border-left 2px #ACACAC dashed
  border-radius: 4px;
  margin-bottom 20px
  // padding: 10px;
  // background-color $secondary
  // color white
.handle
  cursor move
  display inline-block
  vertical-align middle
  width 100%
  height 1.4rem
  border-right 2px #929AAD dashed
  border-bottom 2px #929AAD dashed
  border-left 2px #929AAD dashed
  background-color #ACACAC
.minimized
  color #ccc
  display flex
  justify-content center

.disable-drag
  display inline-block
  vertical-align middle
  width 100%
  height 1.2rem
  border-right 2px #929AAD dashed
  border-bottom 2px #929AAD dashed
  border-left 2px #929AAD dashed
  background-color #CDCDCD

a
  color #606060
  text-decoration none
  &:visited
    color #606060
    text-decoration none
  &:hover
    color #404040
    text-decoration none

</style>
